























import Vue, { PropType } from 'vue';

export default Vue.extend({
    name: 'Checkbox',
    props: {
        id: { type: String, required: false, default: 'customSwitch1' },
        value: { type: Boolean },
        type: { type: String as PropType<'switch' | 'box'>, default: 'switch' },
        disabled: { type: Boolean, default: false },
        // Put checkbox on right side of label
        mirror: { type: Boolean, default: false },
    },
    methods: {
        onChange(evt: Event) {
            if (!evt || !evt.target) return;
            this.$emit('input', Boolean((evt.target as HTMLInputElement).checked));
        },
    },
});
